import { isVideo } from 'utils';
import type { Slide } from 'yet-another-react-lightbox/dist/types';
import type { MediaData } from '../../models';

const nameFromUrl = (url: string) => {
  try {
    return decodeURIComponent(new URL(url).pathname.split('/').pop() || 'image.jpg');
  } catch (e) {
    // Fallback: try to extract filename from the string, or use default
    try {
      return decodeURIComponent(url.split('/').pop() || 'image.jpg');
    } catch {
      return 'image.jpg';
    }
  }
};

export const handleMediaSlides = (media: MediaData[]): Slide[] =>
  media.map((media) => {
    if (isVideo(media)) {
      return {
        type: 'video',
        width: 1280,
        height: 720,
        poster: '/public/poster-image.jpg',
        sources: [{ src: media.contentUrl, type: media.fileType ?? 'video/mp4' }]
      };
    }
    return {
      src: media.contentUrl,
      download: { url: media.contentUrl, filename: nameFromUrl(media.contentUrl) },
      description: media.name
    };
  });
